
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[clientAlias]/economic-impact-assessment-module",
      function () {
        return require("private-next-pages/[clientAlias]/economic-impact-assessment-module/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[clientAlias]/economic-impact-assessment-module"])
      });
    }
  